<template>
  <v-card class="add_tariff">
    <v-form ref="form" v-model="valid">
      <v-row>
        <v-col>
          <v-text-field v-model="title" label="Название тарифа" messages="название тарифа" dense />
        </v-col>
        <v-col>
          <v-combobox v-model="payment_type" :items="payment_items" label="Методы оплаты" multiple dense />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-combobox v-model="comercial_calc" :items="comercal_items" label="Расчеты по коммерции" dense />
        </v-col>
        <v-col>
          <v-combobox v-model="dop_situation_filter" :items="comercal_items" label="Дополнительные фильтры по ситуации"
            dense />
        </v-col>
        <v-col>
          <v-combobox v-model="dop_customer_filter" :items="comercal_items" label="Дополнительные фильтры по заказчикам"
            dense />
        </v-col>
        <v-col>
          <v-combobox v-model="calc_filter" :items="comercal_items" label="Фильтры в результатах расчета" dense />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-checkbox v-model="history_request" label="История расчетов" hide-details />
        </v-col>
        <v-col>
          <v-checkbox v-model="add_users" label="Добавление пользователей (только для ЮЛ и ИП)" hide-details />
        </v-col>
        <v-col>
          <v-checkbox v-model="download_report" label="Скачивание расчета" hide-details />
        </v-col>
        <v-col>
          <v-checkbox v-model="users_report" label="Уведомления пользователей о победах своих клиентов (44-ФЗ, 615-ПП)"
            hide-details />
        </v-col>
        <v-col>
          <v-checkbox v-model="personal_manager" label="Персональный менеджер" hide-details />
        </v-col>
        <!-- <v-col>
          <v-checkbox
            v-model="add_improvement"
            label="Приоритетный учет пожеланий к доработке сервиса"
            hide-details
          />
        </v-col> -->
        <v-col>
          <v-checkbox v-model="telegram_chat" label="Доступ к закрытому агентскому чату в Телеграмм" hide-details />
        </v-col>
        <v-col>
          <v-checkbox v-model="api" label="API для размещения на своём ресурсе" hide-details />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <PriceInput v-model="valid_period" placeholder="Срок действия пакета" />
        </v-col>
        <v-col>
          <PriceInput v-model="count_request" placeholder="Количество запросов" />
        </v-col>
        <v-col>
          <v-text-field v-model="time_support" placeholder="Время ответа техподдержки (не более, рабочее время)" dense />
        </v-col>
        <v-col>
          <PriceInput v-model="price" placeholder="Цена тарифа" />
        </v-col>
      </v-row>
      <v-row>
        <v-col style="display: flex; justify-content: center">
          <v-btn :disabled="!valid" color="success" class="mr-4" @click="AddTariff" v-if="added">
            Добавить
          </v-btn>
          <v-btn :disabled="!valid" color="success" class="mr-4" @click="editTariff" v-else>
            Сохранить изменения
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>
<script>
import PriceInput from "@/components/priceInput.vue";
import Swal from "sweetalert2";
export default {
  name: "add_tariff",
  components: { PriceInput },
  data: () => ({
    valid: false,
    err: false,
    payment_items: ["Без оплаты", "Банковская карта", "на расчетный счет"],
    comercal_items: ["1 в сутки", "+"],
  }),
  computed: {
    id: {
      get() {
        return this.$store.getters.tariff.id;
      },
      set(val) {
        this.$store.commit("setTariffParam", { name: "id", value: val });
      },
    },
    title: {
      get() {
        return this.$store.getters.tariff.title;
      },
      set(val) {
        this.$store.commit("setTariffParam", { name: "title", value: val });
      },
    },
    valid_period: {
      get() {
        return this.$store.getters.tariff.valid_period;
      },
      set(val) {
        this.$store.commit("setTariffParam", {
          name: "valid_period",
          value: val,
        });
      },
    },
    count_request: {
      get() {
        return this.$store.getters.tariff.count_request;
      },
      set(val) {
        this.$store.commit("setTariffParam", {
          name: "count_request",
          value: val,
        });
      },
    },
    api: {
      get() {
        return this.$store.getters.tariff.api;
      },
      set(val) {
        this.$store.commit("setTariffParam", {
          name: "api",
          value: val,
        });
      },
    },
    history_request: {
      get() {
        return this.$store.getters.tariff.history_request;
      },
      set(val) {
        this.$store.commit("setTariffParam", {
          name: "history_request",
          value: val,
        });
      },
    },
    comercial_calc: {
      get() {
        return this.$store.getters.tariff.comercial_calc;
      },
      set(val) {
        this.$store.commit("setTariffParam", {
          name: "comercial_calc",
          value: val,
        });
      },
    },
    dop_situation_filter: {
      get() {
        return this.$store.getters.tariff.dop_situation_filter;
      },
      set(val) {
        this.$store.commit("setTariffParam", {
          name: "dop_situation_filter",
          value: val,
        });
      },
    },
    dop_customer_filter: {
      get() {
        return this.$store.getters.tariff.dop_customer_filter;
      },
      set(val) {
        this.$store.commit("setTariffParam", {
          name: "dop_customer_filter",
          value: val,
        });
      },
    },
    calc_filter: {
      get() {
        return this.$store.getters.tariff.calc_filter;
      },
      set(val) {
        this.$store.commit("setTariffParam", {
          name: "calc_filter",
          value: val,
        });
      },
    },
    add_users: {
      get() {
        return this.$store.getters.tariff.add_users;
      },
      set(val) {
        this.$store.commit("setTariffParam", { name: "add_users", value: val });
      },
    },
    download_report: {
      get() {
        return this.$store.getters.tariff.download_report;
      },
      set(val) {
        this.$store.commit("setTariffParam", {
          name: "download_report",
          value: val,
        });
      },
    },
    users_report: {
      get() {
        return this.$store.getters.tariff.users_report;
      },
      set(val) {
        this.$store.commit("setTariffParam", {
          name: "users_report",
          value: val,
        });
      },
    },
    time_support: {
      get() {
        return this.$store.getters.tariff.time_support;
      },
      set(val) {
        this.$store.commit("setTariffParam", {
          name: "time_support",
          value: val,
        });
      },
    },
    personal_manager: {
      get() {
        return this.$store.getters.tariff.personal_manager;
      },
      set(val) {
        this.$store.commit("setTariffParam", {
          name: "personal_manager",
          value: val,
        });
      },
    },
    add_improvement: {
      get() {
        return this.$store.getters.tariff.add_improvement;
      },
      set(val) {
        this.$store.commit("setTariffParam", {
          name: "add_improvement",
          value: val,
        });
      },
    },
    telegram_chat: {
      get() {
        return this.$store.getters.tariff.telegram_chat;
      },
      set(val) {
        this.$store.commit("setTariffParam", {
          name: "telegram_chat",
          value: val,
        });
      },
    },
    payment_type: {
      get() {
        return this.$store.getters.tariff.payment_type;
      },
      set(val) {
        this.$store.commit("setTariffParam", {
          name: "payment_type",
          value: val,
        });
      },
    },
    price: {
      get() {
        return this.$store.getters.tariff.price;
      },
      set(val) {
        this.$store.commit("setTariffParam", { name: "price", value: val });
      },
    },
    added() {
      return this.$store.getters.added;
    },
  },
  methods: {
    clearForm() {
      this.title = "";
      this.valid_period = null;
      this.count_request = null;
      this.history_request = false;
      this.add_users = false;
      this.download_report = false;
      this.users_report = false;
      this.time_support = null;
      this.personal_manager = false;
      this.add_improvement = false;
      this.telegram_chat = false;
      this.api = false;
      this.payment_type = "";
      this.price = null;
      this.comercial_calc = "";
      this.dop_situation_filter = "";
      this.dop_customer_filter = "";
      this.calc_filter = "";
      this.api = false;
    },
    message(title, text = "") {
      Swal.fire({ icon: "warning", title, text });
      this.err = true;
    },
    savedTariff() {
      return {
        id: this.id,
        title: this.title,
        valid_period: this.valid_period === null ? 0 : this.valid_period,
        count_request: this.count_request === null ? 0 : this.count_request,
        history_request: this.history_request,
        add_users: this.add_users,
        download_report: this.download_report,
        users_report: this.users_report,
        time_support: this.time_support === null ? 0 : this.time_support,
        personal_manager: this.personal_manager,
        add_improvement: this.add_improvement,
        telegram_chat: this.telegram_chat,
        api: this.api,
        payment_type: this.payment_type,
        price: this.price !== null && this.price,
        comercial_calc: this.comercial_calc ? this.comercial_calc : "",
        dop_situation_filter: this.dop_situation_filter
          ? this.dop_situation_filter
          : "",
        dop_customer_filter: this.dop_customer_filter
          ? this.dop_customer_filter
          : "",
        calc_filter: this.calc_filter ? this.calc_filter : "",
      };
    },
    async AddTariff() {
      if (this.valid_period === null) {
        this.message("Заполните период");
      } else if (this.count_request === null) {
        this.message("Заполните количество запросов");
      } else if (this.price === null) {
        this.message("Цена обязательное поле");
      } else {
        await this.$store.dispatch("ADD_PAYMENTS_TARIFFS", this.savedTariff());
        this.clearForm();
      }
    },
    async editTariff() {
      this.$store.dispatch("EDIT_PAYMENTS_TARIFFS", this.savedTariff());
      this.$store.commit("setAdded", true);
      this.clearForm();
    },
  },
};
</script>
<style lang="sass" scoped>
.add_tariff
  padding: 10px
</style>
